
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/fyrirtaekid/bannmerking",
      function () {
        return require("private-next-pages/um/fyrirtaekid/bannmerking.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/fyrirtaekid/bannmerking"])
      });
    }
  